module.exports = __webpack_public_path__ + "img/bars-solid.b3f49afd.svg";